import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';

import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { DragBox, Draw } from 'ol/interaction';
import { Fill, Stroke, Style } from 'ol/style';
import CircleS from 'ol/style/Circle';
import {
  LinearRing,
  LineString,
  MultiLineString,
  MultiPoint,
  MultiPolygon,
  Point,
  Polygon,
} from 'ol/geom';
import WKT from 'ol/format/WKT';
import buffer from '@turf/buffer';
import GeoJSON from 'ol/format/GeoJSON';
import { toMercator } from '@turf/projection';
import { GlobalService } from 'src/app/services/global.service';
import Feature from 'ol/Feature';
import { HttpClient } from '@angular/common/http';
import { MapServiceService } from '../../../services/Map-service/map-service.service';
import { SideNavService } from '../../../services/sidenav/side-nav.service';
declare let jsts: any;
@Component({
  selector: 'app-advance-select',
  templateUrl: './advance-select.component.html',
  styleUrls: ['./advance-select.component.css'],
})
export class AdvanceSelectComponent implements OnInit, OnDestroy {
  innerData: any = [];
  unionResult: any = [];
  allLayers: Array<any> = [];
  getData: Array<any> = [];
  allInnerFeature: any = [];
  buffers: any = [];
  notUnioned: any = [];
  insideBuffers: any = [];
  selectedBuffers: any = [];
  toolData: any;
  layers: any;
  type: any;
  bufferStyle: any;
  reader: any;
  parcel: any;
  singleData: any;
  buffer: any;
  feature: any
  selectedFeatures: any;
  unionfound: any;
  finalFeature: any;
  sketch: any;
  resData: any;
  listener: any;
  outputLength: any;
  eventName: any;
  outputArea: any;
  vectorDrawSource: any;
  featureone: any;
  getAllLayers: any;
  allLayersId: any;
  loginUSer: any;
  unionCount: any;
  event: any;
  currentWkt: any;
  logEvent: any;
  ctrlRes: any;
  bufferValue: any;
  selectlayer: any;
  union: any;
  nextGeom: any;
  currentGeom: any;
  intersection: any;
  measureType: any;
  data: any;
  selectionMenu: any;
  multiBuffered: any
  bufferInner: any;
  mapId: any;
  radius: any;
  showMeg: any;
  layersId: any;
  selectedMethod: any;
  advanceLayer: any;
  pointGeometry: any;
  polygonGeometry: any;
  bufferShow: any;
  draw: any;
  rmInteraction: any;
  selectedFeature: any;
  selectedBuffer: any;
  feet: any;
  searchFeatures: any;
  buffered: any;
  bufferArea: any;
  kilometers: any;
  meters: any;
  miles: any;
  ctrlData: any;
  uniqFeatureData: any;
  html: any;
  tooltips: any;
  layerState: any;
  selectedSubMethod: any;
  selectionMethod: any;
  boundaries: any;
  unitestpass: any;
  advanceSelectJson: any;
  featureExist = false;
  ctrlCheck = false;
  count = 0;
  Show: any = false;
  ctrlPress: any = false;
  selectMenu = true;
  bufferFeature = true;
  polygonWithClick = true;
  polygonWithCtrl = false;
  unitesting: any = false;
  selectAll = true;
  showBufferParcel: any = false;
  insideFeature: any
  parcelLength = '1';
  slectedUnion = '1';
  advanceToolTip = 'Clear Selection';
  polygonAnnotation = 'false';
  linesAnnotation = 'false';
  pointSAnnotation = 'false';
  defaultSelect = 'Feet';

  myOptions1 = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class',
  };
  myOptions2 = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class2',
  };

  myOptions3 = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class3',
  };
  myOptions4 = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class4',
  };
  constructor(
    public sideNavService: SideNavService,
    public mapServices: MapServiceService,
    private global: GlobalService,
    private http: HttpClient
  ) {
    //
  }

  ngOnInit(): void {
    this.sideNavService.ctrlCheck.subscribe((res1: any) => {
      this.ctrlPress = res1;
    });
    // this.mapServices.innerBuffer = []
    // this.mapServices.bufferPolygonGeometry = []
    this.mapServices.ParcelData = [];
    //
    this.selectMenu = true;
    if (
      !this.mapServices.accessMapApi.map_data.map_data.tool_desc[
        'advanced-select'
      ]
    ) {
      this.html = '';
    } else {
      this.html =
        this.mapServices.accessMapApi.map_data.map_data.tool_desc[
          'advanced-select'
        ];
    }
    this.buffer = this.mapServices.mapData.map_data.map_data.tools['buffer'];
    this.boundaries = this.mapServices.mapData.map_data.map_data.layers;
    this.tooltips = this.mapServices.accessMapApi.map_data.map_data.tools_tips;
    this.layers = this.mapServices.mapData.map_data.map_data.layers;
    this.layersId = this.mapServices.getLayersId().toString();
    this.mapId = this.mapServices.mapData.map_data.map_data.id.toString();

    this.vectorDrawSource = new VectorSource();
    this.advanceLayer = new VectorLayer({
      source: this.vectorDrawSource,
    });

    this.mapServices.mapLayer.addLayer(this.advanceLayer);
    this.measureType = 'Feet';
    this.layerState = this.sideNavService.advanceSelectLayer;
    this.selectedBuffer = this.sideNavService.selectedBuffer;

    if (!this.sideNavService.advanceSelectState) {
      this.sideNavService.advanceSelectState = {
        location: '',
        box: 'Circle',
        lasso: '',
        buffer: '',
      };
    } else {
      this.selectedMethod = this.sideNavService.advanceSelectState;
    }
    this.selectedSubMethod = this.sideNavService.selectedSubMethod;
    this.bufferValue = this.sideNavService.bufferValue;
    this.bufferShow = this.sideNavService.bufferShow;
    this.mapServices.bufferShowFiles.subscribe((res: any) => {
      this.Show = res;
      this.sideNavService.showAdvanceNowSelect = this.Show;
    });
    this.loginUSer = localStorage.getItem('userAccessLevel');
    if (this.sideNavService.sidenav.opened) {
      const event = { target: { checked: true, value: this.layerState } };
      if (this.sideNavService.advanceSelectState.location) {
        this.selectMethod(this.sideNavService.advanceSelectState.location);
        this.layerSelect(event);
      } else if (this.sideNavService.advanceSelectState.box) {
        this.selectMethod(this.sideNavService.advanceSelectState.box);
        this.layerSelect(event);
      } else if (this.sideNavService.advanceSelectState.lasso) {
        this.selectMethod(this.sideNavService.advanceSelectState.lasso);
        this.layerSelect(event);
      } else if (this.sideNavService.advanceSelectState.buffer) {
        this.selectMethod(this.sideNavService.advanceSelectState.buffer);
        this.layerSelect(event);
      }
    }
  }
  layerSelect(e: any): void {
    this.selectlayer = e.target.value;
    switch (this.selectedMethod) {
      case 'Point':
        this.selectionMenu = 'Location';
        break;
      case 'Circle':
        this.selectionMenu = 'Box';
        break;
      case 'Polygon':
        this.selectionMenu = 'Lasso';
        break;
      default:
        this.selectionMenu = this.selectedMethod;
        break;
    }
    this.eventName =
      'AdvanceSelect:' + `${this.selectionMenu}` + `${':'}` + `Select`;
      this.advanceSelectJson = {
        advanced_select_layer: `${
          this.sideNavService.advanceSelectLayer == 'allLayers'
            ? 'All_Layers'
            : this.sideNavService.advanceSelectLayer
        }`,
      };
      this.advanceSelectJson = JSON.stringify(this.advanceSelectJson);
    this.sideNavService.advanceSelectLayer = e.target.value;
    this.layerState = this.sideNavService.advanceSelectLayer;

    if (this.selectlayer === 'allLayers') {
      this.layersId = '';
      this.getAllLayers = this.mapServices.mapData.map_data.map_data.layers;
      this.layersId = this.mapServices.getLayersId().toString();
      this.mapServices.selectedLayersId = this.getAllLayers.map(
        ({ id }: any) => id
      );
    } else {
      this.layersId = '';
      const allLayers = this.mapServices.mapData.map_data.map_data.layers;
      for (let i = 0; i <= allLayers.length; i++) {
        if (allLayers[i]?.name == this.selectlayer) {
          // this.layerSelect
          this.layersId = allLayers[i].id.toString();
          this.mapServices.showBuffferField = this.layersId;
          this.mapServices.selectedLayersId = allLayers[i].id.toString();
        }
      }
    }
    this.selectedMethod = this.sideNavService.advanceSelectState;
  }

  selectMethod(e: any): any {
    this.count = this.count + 1;
    this.selectedMethod = e;
    switch (e) {
      case 'Point':
        this.selectionMenu = 'Location';
        break;
      case 'Circle':
        this.selectionMenu = 'Box';
        break;
      case 'Polygon':
        this.selectionMenu = 'Lasso';
        break;
      default:
        this.selectionMenu = this.selectedMethod;
        break;
    }
    this.eventName = 'AdvancedSelect:' + `${this.selectionMenu}` + ':Select';
    this.advanceSelectJson = {
      advanced_select_layer: `${
        this.sideNavService.advanceSelectLayer == 'allLayers'
          ? 'All_Layers'
          : this.sideNavService.advanceSelectLayer
      }`,
    };
    this.advanceSelectJson = JSON.stringify(this.advanceSelectJson);
    if (this.count > 1) {
      // this.activityLoging();
    }
    this.mapServices.mapLayer.updateSize();
    this.mapServices.mapLayer.removeInteraction(this.draw);
    this.advanceLayer.getSource().clear();
    if (!this.selectedMethod) {
      this.selectedFeature = 'None';
    } else if (this.selectedMethod === 'Circle') {
      this.bufferShow = false;
      this.sideNavService.bufferShow = this.bufferShow;
      this.sideNavService.advanceSelectState = {
        location: '',
        box: '',
        lasso: '',
        buffer: '',
      };
      this.sideNavService.advanceSelectState.box = e;
      this.selectedFeature = 'Box';
      this.selectedBuffer = 'Box';
      this.sideNavService.selectedBuffer = this.selectedBuffer;
      // this.selectedBuffer  = this.sideNavService.selectedBuffer
    } else if (this.selectedMethod === 'Polygon') {
      this.bufferShow = false;
      this.sideNavService.bufferShow = this.bufferShow;
      this.sideNavService.advanceSelectState = {
        location: '',
        box: '',
        lasso: '',
        buffer: '',
      };
      this.sideNavService.advanceSelectState.lasso = e;
      this.selectedFeature = 'Lasso';
      this.selectedBuffer = 'Lasso';
      this.sideNavService.selectedBuffer = this.selectedBuffer;
      // this.selectedBuffer  = this.sideNavService.selectedBuffer
    } else if (this.selectedMethod === 'Buffer') {
      this.sideNavService.advanceSelectState = {
        location: '',
        box: '',
        lasso: '',
        buffer: '',
      };
      this.mapServices.getdrawEnable(false);
      this.sideNavService.advanceSelectState.buffer = e;
      this.selectedMethod = 'Point';
      this.selectedBuffer = 'Buffer';
      this.sideNavService.selectedBuffer = this.selectedBuffer;
      //  this.selectedBuffer  = this.sideNavService.selectedBuffer
      this.selectedFeature = 'Buffer';
      this.showSelectParcel();
    } else {
      this.selectedFeature = this.selectedMethod;
      this.sideNavService.advanceSelectState = {
        location: '',
        box: '',
        lasso: '',
        buffer: '',
      };
      this.mapServices.getdrawEnable(false);
      this.sideNavService.advanceSelectState.location = e;
      this.selectedBuffer = 'Point';
      this.sideNavService.selectedBuffer = this.selectedBuffer;
      this.bufferShow = false;
      this.sideNavService.bufferShow = this.bufferShow;
      if (this.ctrlPress) {
        this.mapServices.mapLayer.removeInteraction(this.draw);
      }
    }
    if (this.selectedMethod === 'Polygon' || this.selectedMethod === 'Circle') {
      this.mapServices.getdrawEnable(true);
      this.addInteraction();
    }
  }

  showSelectParcel() {
    if (this.Show) {
      this.showMeg = true;
    } else if (this.selectedBuffer === 'Buffer' && !this.Show) {
      this.showMeg = true;
    }
  }

  addInteraction() {
    const layer = this.advanceLayer;
    if (this.selectedMethod === 'Polygon') {
      this.draw = new Draw({
        source: layer.getSource(),
        condition: this.drawCondition,
        type: this.selectedMethod,
        style: new Style({
          stroke: new Stroke({
            color: '#3985da',
            width: 5,
          }),

          image: new CircleS({
            radius: 0,
            stroke: new Stroke({
              color: 'rgb(238, 153, 0)',
            }),
            fill: new Fill({
              color: '#ffcc33',
            }),
          }),
        }),
      });

      this.rmInteraction = this.draw;
      this.mapServices.mapLayer.addInteraction(this.draw);
      //for unit test
      this.draw.on('drawstart', () => {
        this.unitestpass = true;
      });

      this.draw.on('drawend', (evt: any) => {
        this.unitestpass = true;
        this.advanceLayer.getSource().clear();
        this.sketch = evt.feature;
        const geom = evt.feature.getGeometry();
        if (geom instanceof Polygon) {
          this.pointGeometry = '';
          this.polygonGeometry = '';
          const wkt = new WKT();
          this.polygonGeometry = wkt.writeGeometry(geom);
          this.mapServices.polygonGeometry = wkt.writeGeometry(geom);
        }
        // this.getAdvanceSelect();
        this.getCoordinatesData()
        this.activityLoging();

        const style = new Style({});
        evt.feature.setStyle(style);
        this.advanceLayer && this.advanceLayer.getSource().clear();
      });
    } else if (this.selectedMethod === 'Circle') {
      this.draw = new DragBox({
        className: 'drag',
      });
      this.rmInteraction = this.draw;
      this.mapServices.mapLayer.addInteraction(this.draw);
      this.draw.on('boxstart', () => {
        this.unitestpass = true;
      });
      this.draw.on('boxend', (evt: any) => {
        const geom = evt.target.getGeometry();
        this.pointGeometry = '';
        this.polygonGeometry = '';
        const wkt = new WKT();
        this.polygonGeometry = wkt.writeGeometry(geom);
        this.mapServices.polygonGeometry = wkt.writeGeometry(geom);
        // this.getAdvanceSelect();
        this.getCoordinatesData()
        this.activityLoging();

        this.mapServices.getdrawEnable(false);
      });

      //unit test checks

      this.advanceLayer && this.advanceLayer.getSource().clear();
    }
    //for unit testing
    if (this.unitesting && this.selectedMethod === 'Circle') {
      this.draw.dispatchEvent('boxstart');
    }
    if (this.unitesting && this.selectedMethod === 'Polygon') {
      if (this.selectedMethod === 'Polygon') {
        this.draw.appendCoordinates([
          [36.301744, 50.010456],
          [36.30218, 50.019864],
          [36.301025, 50.02173],
          [36.293856, 50.016215],
          [36.293682, 50.00924],
          [36.301744, 50.010456],
        ]);
        // this.draw.finishDrawing();
      }
    }
    //unit test checks ends
  }
  drawCondition() {
    return true;
  }
  uniqByKeepFirst(a: any, key: any) {
    const seen = new Set();
    return a.filter((item: any) => {
      const k = key(item);
      return seen.has(k) ? false : seen.add(k);
    });
  }

  getAdvanceSelect() {
    this.mapServices.allBuffersFeatures = [];
    this.mapServices.selectedBufferData = [];
    //check for hidding data panel and then show
    if (this.sideNavService.hideRightPanelForImage) {
      this.sideNavService.closeRightSideNav();
      // this.sideNavService.showAnimateNow = false;
      this.sideNavService.hideRightPanelForImage = false;
    }
    this.mapServices.stopHover = true;

    for (let i = 0; i <= this.boundaries.length; i++) {
      if (
        this.layersId.includes(this.boundaries[i]?.id.toString()) &&
        (this.boundaries[i]?.name === 'Parcels' ||
          this.boundaries[i]?.name === 'Tehama County Parcels' ||
          this.boundaries[i]?.name === 'Glenn County Parcels')
      ) {
        this.mapServices.getbufferShowFiles(true);
        this.mapServices.isParcelLayer = true;
        break;
      } else {
        this.mapServices.getbufferShowFiles(false);
        this.mapServices.isParcelLayer = false;
      }
    }
    if (!this.ctrlPress) {
      this.mapServices.lastLabel = '0';
    }
    this.global.toggleLoader(true);
    this.mapServices.lastLabel = '0';
    this.mapServices
      .getSearchCoordinates(
        this.mapId,
        // this.layersId,
        this.layersId,
        this.polygonGeometry,
        this.pointGeometry,
        this.parcelLength,
        this.slectedUnion,
        this.ctrlPress.toString(),
        this.polygonAnnotation,
        this.linesAnnotation,
        this.pointSAnnotation,
        this.mapServices.mapLayer.getView().getResolution().toString(),
        this.selectedFeature,
        this.mapServices.preSelectedAnnotation,
        '',
        this.mapServices.currentMapZoom
      )
      .subscribe((res) => {
        this.mapServices.lastLabel =
          res.features.length &&
          res.features[res.features.length - 1].label.toString();
        if (this.ctrlPress && !this.showBufferParcel) {
          this.mapServices.ctrlPush = this.ctrlPress;
          this.resData = res;
          this.ctrlData = '';
          this.uniqFeatureData = '';
          const dataFeature = this.mapServices.ParcelData;
          const featuresInBoth = [];
          const featuresOnlyInFeatures1 = [];
          const featuresOnlyInFeatures2 = [];
          this.featureExist = false;
          // Iterate over features1 array
          for (let i = 0; i < this.resData.features.length; i++) {
            const feature1 = this.resData.features[i];

            // Check if the feature exists in features2 array
            const feature2 = dataFeature.find((f: any) => f.id === feature1.id);

            if (feature2) {
              // The feature exists in both arrays
              featuresInBoth.push(feature1);
            } else {
              // The feature exists only in features1 array
              featuresOnlyInFeatures1.push(feature1);
              this.featureExist = false;
            }
          }

          // Iterate over features2 array
          for (let i = 0; i < dataFeature.length; i++) {
            const feature2 = dataFeature[i];

            // Check if the feature exists in features1 array
            const feature1 = this.resData.features.find((f: any) => f.id === feature2.id);

            if (!feature1) {
              // The feature exists only in features2 array
              featuresOnlyInFeatures2.push(feature2);
            }
          }

          // Log the results
          console.log("Features in both arrays:", featuresInBoth);
          console.log("Features only in features1 array:", featuresOnlyInFeatures1);
          console.log("Features only in features2 array:", featuresOnlyInFeatures2);
          this.featureExist = false;
          if(featuresOnlyInFeatures1.length == 0 ) {
            this.featureExist = true;
          }
          if (this.featureExist) {
            this.uniqFeatureData = featuresOnlyInFeatures2;
          } else {
              if (dataFeature.length < this.sideNavService.searchLimit) {
                this.ctrlData = [...featuresInBoth, ...featuresOnlyInFeatures1,...featuresOnlyInFeatures2]
                this.uniqFeatureData = this.uniqByKeepFirst(
                  this.ctrlData,
                  (it: any) => it.id
                );
              } else {
                //prevent adding more features when limit full
                this.uniqFeatureData = featuresOnlyInFeatures2;
              }
          }
          this.mapServices.ParcelData = [];
          this.mapServices.ParcelData = this.uniqFeatureData;
          this.ctrlRes = { features: this.uniqFeatureData };
          this.selectedFeatures = this.ctrlRes.features;
          const fields: any = {};
          if (this.selectedFeatures.length > 1) {
            this.mapServices.parcel = '';
            this.mapServices.parcels = [];
            for (let i = 0; i < this.selectedFeatures.length; i++) {
              this.mapServices.multiParcelId.push(this.selectedFeatures[i].id);
              if (fields[this.selectedFeatures[i].layer_id]) {
                fields[this.selectedFeatures[i].layer_id.toString()].push(
                  this.selectedFeatures[i].id.toString()
                );
              } else {
                fields[this.selectedFeatures[i].layer_id] = [];
                fields[this.selectedFeatures[i].layer_id.toString()].push(
                  this.selectedFeatures[i].id.toString()
                );
              }
              this.mapServices.parcel = JSON.stringify(fields);
              this.mapServices.featureLayersId.push(
                this.selectedFeatures[i].layer_id
              );
              this.mapServices.featureLayerId = [
                ...new Set(this.mapServices.featureLayersId),
              ].toString();
            }
          } else {
            this.mapServices.parcel = '';
            this.mapServices.parcels = [];
            for (let i = 0; i < this.selectedFeatures.length; i++) {
              this.mapServices.multiParcelId.push(this.selectedFeatures[i].id);
              // multiParcel
              this.mapServices.multiParcel = false;
              // parcel ID
              this.mapServices.parcels.push(this.selectedFeatures[i].id);
              this.mapServices.parcel = [
                ...new Set(this.mapServices.parcels),
              ].toString();
              // Feature Layer Id
              this.mapServices.featureLayersId.push(
                this.selectedFeatures[i].layer_id
              );
              this.mapServices.featureLayerId = [
                ...new Set(this.mapServices.featureLayersId),
              ].toString();
            }
          }
          this.sideNavService.decideComponent(this.ctrlRes);
        } else if (!this.showBufferParcel) {
          this.removeBuffer()
          this.selectedFeatures = res.features;
          this.singleData = res;
          const fields: any = {};
          if (this.selectedFeatures.length > 1) {
            this.mapServices.parcel = '';
            this.mapServices.parcels = [];
            for (let i = 0; i < this.selectedFeatures.length; i++) {
              this.mapServices.multiParcelId.push(this.selectedFeatures[i].id);
              if (fields[this.selectedFeatures[i].layer_id]) {
                fields[this.selectedFeatures[i].layer_id.toString()].push(
                  this.selectedFeatures[i].id.toString()
                );
              } else {
                fields[this.selectedFeatures[i].layer_id] = [];
                fields[this.selectedFeatures[i].layer_id.toString()].push(
                  this.selectedFeatures[i].id.toString()
                );
              }
              this.mapServices.parcel = JSON.stringify(fields);
              this.mapServices.featureLayersId.push(
                this.selectedFeatures[i].layer_id
              );
              this.mapServices.featureLayerId = [
                ...new Set(this.mapServices.featureLayersId),
              ].toString();
            }
          } else {
            this.mapServices.parcel = '';
            this.mapServices.parcels = [];
            for (let i = 0; i < this.selectedFeatures.length; i++) {
              this.mapServices.multiParcelId.push(this.selectedFeatures[i].id);
              // multiParcel
              this.mapServices.multiParcel = false;
              // parcel ID
              this.mapServices.parcels.push(this.selectedFeatures[i].id);
              this.mapServices.parcel = [
                ...new Set(this.mapServices.parcels),
              ].toString();
              // Feature Layer Id
              this.mapServices.featureLayersId.push(
                this.selectedFeatures[i].layer_id
              );
              this.mapServices.featureLayerId = [
                ...new Set(this.mapServices.featureLayersId),
              ].toString();
            }
          }
          this.mapServices.ParcelData = [];
          this.mapServices.ParcelData = res.features;
          this.sideNavService.decideComponent(this.singleData);
        } else if (this.showBufferParcel) {
          this.removeBuffer()
          this.mapServices.allBuffersFeatures.push(...res.features);
          this.mapServices.selectedBufferData.push(...res.features);
          const fields: any = {};
          if (this.mapServices.allBuffersFeatures.length > 1) {
            this.mapServices.parcel = '';
            this.mapServices.parcels = [];
            for (
              let i = 0;
              i < this.mapServices.allBuffersFeatures.length;
              i++
            ) {
              this.mapServices.multiParcelId.push(
                this.mapServices.allBuffersFeatures[i].id
              );
              if (fields[this.mapServices.allBuffersFeatures[i].layer_id]) {
                fields[
                  this.mapServices.allBuffersFeatures[i].layer_id.toString()
                ].push(this.mapServices.allBuffersFeatures[i].id.toString());
              } else {
                fields[this.mapServices.allBuffersFeatures[i].layer_id] = [];
                fields[
                  this.mapServices.allBuffersFeatures[i].layer_id.toString()
                ].push(this.mapServices.allBuffersFeatures[i].id.toString());
              }
              this.mapServices.parcel = JSON.stringify(fields);
              this.mapServices.featureLayersId.push(
                this.mapServices.allBuffersFeatures[i].layer_id
              );
              this.mapServices.featureLayerId = [
                ...new Set(this.mapServices.featureLayersId),
              ].toString();
            }
          } else {
            this.mapServices.parcel = '';
            this.mapServices.parcels = [];
            for (
              let i = 0;
              i < this.mapServices.allBuffersFeatures.length;
              i++
            ) {
              this.mapServices.multiParcelId.push(
                this.mapServices.allBuffersFeatures[i].id
              );
              // multiParcel
              this.mapServices.multiParcel = false;
              // parcel ID
              this.mapServices.parcels.push(
                this.mapServices.allBuffersFeatures[i].id
              );
              this.mapServices.parcel = [
                ...new Set(this.mapServices.parcels),
              ].toString();
              // Feature Layer Id
              this.mapServices.featureLayersId.push(
                this.mapServices.allBuffersFeatures[i].layer_id
              );
              this.mapServices.featureLayerId = [
                ...new Set(this.mapServices.featureLayersId),
              ].toString();
            }
          }
          this.mapServices.getbufferShowFiles(true);
          this.mapServices.isParcelLayer = true;
          this.mapServices.ParcelData = [];
          this.mapServices.ParcelData = this.mapServices.allBuffersFeatures;
          this.sideNavService.decideComponent(
            this.mapServices.selectedBufferData
          );
        }
      });
  }

  compareIds(array1: any, array2: any) {
    const ids1 = array1.map((obj: any) => obj.id);
    const ids2 = array2.map((obj: any) => obj.id);
    for (let i = 0; i < ids1.length; i++) {
      if (ids1[i] !== ids2[i]) {
        return false;
      }
    }

    return true;
  }


  getCoordinatesData() {
    this.mapServices.allBuffersFeatures = [];
    this.mapServices.selectedBufferData = [];
    //check for hidding data panel and then show
    if (this.sideNavService.hideRightPanelForImage) {
      this.sideNavService.closeRightSideNav();
      // this.sideNavService.showAnimateNow = false;
      this.sideNavService.hideRightPanelForImage = false;
    }
    this.mapServices.stopHover = true;

    for (let i = 0; i <= this.boundaries.length; i++) {
      if (
        this.layersId.includes(this.boundaries[i]?.id.toString()) &&
        (this.boundaries[i]?.name === 'Parcels' ||
          this.boundaries[i]?.name === 'Tehama County Parcels' ||
          this.boundaries[i]?.name === 'Glenn County Parcels')
      ) {
        this.mapServices.getbufferShowFiles(true);
        this.mapServices.isParcelLayer = true;
        break;
      } else {
        this.mapServices.getbufferShowFiles(false);
        this.mapServices.isParcelLayer = false;
      }
    }
    if (!this.ctrlPress) {
      this.mapServices.perviousLabel = '0'
    }
    this.global.toggleLoader(true);
    const subLevel = localStorage.getItem('subLevel') || 500;
    const shareId = localStorage.getItem('shareId');
    const body = {
      map_id:this.mapId,
        // this.layersId,
        layer_ids:this.layersId,
        wkt:this.polygonGeometry,
        point_coordinates:this.pointGeometry,
        parcel_length:this.parcelLength,
        selected_union:this.slectedUnion,
        ctrl_check:this.ctrlPress.toString(),
        polygon_annotation:this.polygonAnnotation,
        line_annotation:this.linesAnnotation,
        point_annotation:this.pointSAnnotation,
        map_resolution:this.mapServices.mapLayer.getView().getResolution().toString(),
        selected_feature:this.selectedFeature,
        pre_selected_annotation:this.mapServices.preSelectedAnnotation,
        annotation_id:'',
        zoom:this.mapServices.currentMapZoom,
    }
    this.mapServices
      .searchParcels(
        body
      )
      .subscribe((res) => {
        this.mapServices.perviousLabel = res.features.length && res.features[res.features.length - 1].label.toString();
        if (this.ctrlPress && !this.showBufferParcel) {
          this.mapServices.ctrlPush = this.ctrlPress;
          this.resData = res;
          this.ctrlData = '';
          this.uniqFeatureData = '';
          const dataFeature = this.mapServices.ParcelData;
          const featuresInBoth = [];
          const featuresOnlyInFeatures1 = [];
          const featuresOnlyInFeatures2 = [];
          this.mapServices.innerBuffer = []
          this.featureExist = false;
          // Iterate over features1 array
          for (let i = 0; i < this.resData.features.length; i++) {
            const feature1 = this.resData.features[i];
            // Check if the feature exists in features2 array
            const feature2 = dataFeature.find((f: any) => f.id === feature1.id);
            if (feature2) {
              // The feature exists in both arrays
              featuresInBoth.push(feature1);
            } else {
              // The feature exists only in features1 array
              featuresOnlyInFeatures1.push(feature1);
              this.featureExist = false;
            }
          }
          // Iterate over features2 array
          for (let i = 0; i < dataFeature.length; i++) {
            const feature2 = dataFeature[i];
            // Check if the feature exists in features1 array
            const feature1 = this.resData.features.find((f: any) => f.id === feature2.id);
            if (!feature1) {
              // The feature exists only in features2 array
              featuresOnlyInFeatures2.push(feature2);
            }
          }
          // Log the results
          console.log("Features in both arrays:", featuresInBoth);
          console.log("Features only in features1 array:", featuresOnlyInFeatures1);
          console.log("Features only in features2 array:", featuresOnlyInFeatures2);
          this.featureExist = false;
          if(featuresOnlyInFeatures1.length == 0 ) {
            this.featureExist = true;
          }
          if (this.featureExist) {
            this.uniqFeatureData = featuresOnlyInFeatures2;
          } else {
              if (dataFeature.length < this.sideNavService.searchLimit) {
                this.ctrlData = [...featuresInBoth, ...featuresOnlyInFeatures1,...featuresOnlyInFeatures2]
                this.uniqFeatureData = this.uniqByKeepFirst(
                  this.ctrlData,
                  (it: any) => it.id
                );
              } else {
                //prevent adding more features when limit full
                this.uniqFeatureData = featuresOnlyInFeatures2;
              }
          }
          this.mapServices.ParcelData = [];
          this.mapServices.ParcelData = this.uniqFeatureData;
          this.ctrlRes = { features: this.uniqFeatureData };
          this.selectedFeatures = this.ctrlRes.features;
          const highestLabel = this.selectedFeatures.reduce((prevObj: any, currentObj: any) => {
            return (prevObj.label > currentObj.label) ? prevObj : currentObj;
          }).label;
          this.mapServices.perviousLabel = highestLabel
          const fields: any = {};
          if (this.selectedFeatures.length > 1) {
            this.mapServices.parcel = '';
            this.mapServices.parcels = [];
            for (let i = 0; i < this.selectedFeatures.length; i++) {
              this.mapServices.innerBuffer.push(this.selectedFeatures[i].geom_wkt)
              this.mapServices.multiParcelId.push(this.selectedFeatures[i].id);
              if (fields[this.selectedFeatures[i].layer_id]) {
                fields[this.selectedFeatures[i].layer_id.toString()].push(
                  this.selectedFeatures[i].id.toString()
                );
              } else {
                fields[this.selectedFeatures[i].layer_id] = [];
                fields[this.selectedFeatures[i].layer_id.toString()].push(
                  this.selectedFeatures[i].id.toString()
                );
              }
              this.mapServices.parcel = JSON.stringify(fields);
              this.mapServices.featureLayersId.push(
                this.selectedFeatures[i].layer_id
              );
              this.mapServices.featureLayerId = [
                ...new Set(this.mapServices.featureLayersId),
              ].toString();
            }
          } else {
            this.mapServices.parcel = '';
            this.mapServices.parcels = [];
            this.mapServices.innerBuffer = []
            for (let i = 0; i < this.selectedFeatures.length; i++) {
              this.mapServices.multiParcelId.push(this.selectedFeatures[i].id);
              // multiParcel
              this.mapServices.multiParcel = false;
              // parcel ID
              this.mapServices.parcels.push(this.selectedFeatures[i].id);
              this.mapServices.parcel = [
                ...new Set(this.mapServices.parcels),
              ].toString();
              // Feature Layer Id
              this.mapServices.featureLayersId.push(
                this.selectedFeatures[i].layer_id
              );
              this.mapServices.featureLayerId = [
                ...new Set(this.mapServices.featureLayersId),
              ].toString();
            }
          }
          this.sideNavService.decideComponent(this.ctrlRes);
        } else if (!this.showBufferParcel) {
          this.removeBuffer()
          this.selectedFeatures = res.features;
          this.singleData = res;
          const fields: any = {};
          if (this.selectedFeatures.length > 1) {
            this.mapServices.parcel = '';
            this.mapServices.parcels = [];
            for (let i = 0; i < this.selectedFeatures.length; i++) {
              this.mapServices.innerBuffer.push(this.selectedFeatures[i].geom_wkt)
              this.mapServices.multiParcelId.push(this.selectedFeatures[i].id);
              if (fields[this.selectedFeatures[i].layer_id]) {
                fields[this.selectedFeatures[i].layer_id.toString()].push(
                  this.selectedFeatures[i].id.toString()
                );
              } else {
                fields[this.selectedFeatures[i].layer_id] = [];
                fields[this.selectedFeatures[i].layer_id.toString()].push(
                  this.selectedFeatures[i].id.toString()
                );
              }
              this.mapServices.parcel = JSON.stringify(fields);
              this.mapServices.featureLayersId.push(
                this.selectedFeatures[i].layer_id
              );
              this.mapServices.featureLayerId = [
                ...new Set(this.mapServices.featureLayersId),
              ].toString();
            }
          } else {
            this.mapServices.parcel = '';
            this.mapServices.parcels = [];
            for (let i = 0; i < this.selectedFeatures.length; i++) {
              this.mapServices.multiParcelId.push(this.selectedFeatures[i].id);
              // multiParcel
              this.mapServices.multiParcel = false;
              // parcel ID
              this.mapServices.parcels.push(this.selectedFeatures[i].id);
              this.mapServices.parcel = [
                ...new Set(this.mapServices.parcels),
              ].toString();
              // Feature Layer Id
              this.mapServices.featureLayersId.push(
                this.selectedFeatures[i].layer_id
              );
              this.mapServices.featureLayerId = [
                ...new Set(this.mapServices.featureLayersId),
              ].toString();
            }
          }
          this.mapServices.ParcelData = [];
          this.mapServices.ParcelData = res.features;
          this.sideNavService.decideComponent(this.singleData);
        } else if (this.showBufferParcel) {
          // this.removeBuffer()
          this.mapServices.allBuffersFeatures.push(...res.features);
          this.mapServices.selectedBufferData.push(...res.features);
          const fields: any = {};
          if (this.mapServices.allBuffersFeatures.length > 1) {
            this.mapServices.parcel = '';
            this.mapServices.parcels = [];
            for (
              let i = 0;
              i < this.mapServices.allBuffersFeatures.length;
              i++
            ) {
              this.mapServices.multiParcelId.push(
                this.mapServices.allBuffersFeatures[i].id
              );
              if (fields[this.mapServices.allBuffersFeatures[i].layer_id]) {
                fields[
                  this.mapServices.allBuffersFeatures[i].layer_id.toString()
                ].push(this.mapServices.allBuffersFeatures[i].id.toString());
              } else {
                fields[this.mapServices.allBuffersFeatures[i].layer_id] = [];
                fields[
                  this.mapServices.allBuffersFeatures[i].layer_id.toString()
                ].push(this.mapServices.allBuffersFeatures[i].id.toString());
              }
              this.mapServices.parcel = JSON.stringify(fields);
              this.mapServices.featureLayersId.push(
                this.mapServices.allBuffersFeatures[i].layer_id
              );
              this.mapServices.featureLayerId = [
                ...new Set(this.mapServices.featureLayersId),
              ].toString();
            }
          } else {
            this.mapServices.parcel = '';
            this.mapServices.parcels = [];
            for (
              let i = 0;
              i < this.mapServices.allBuffersFeatures.length;
              i++
            ) {
              this.mapServices.multiParcelId.push(
                this.mapServices.allBuffersFeatures[i].id
              );
              // multiParcel
              this.mapServices.multiParcel = false;
              // parcel ID
              this.mapServices.parcels.push(
                this.mapServices.allBuffersFeatures[i].id
              );
              this.mapServices.parcel = [
                ...new Set(this.mapServices.parcels),
              ].toString();
              // Feature Layer Id
              this.mapServices.featureLayersId.push(
                this.mapServices.allBuffersFeatures[i].layer_id
              );
              this.mapServices.featureLayerId = [
                ...new Set(this.mapServices.featureLayersId),
              ].toString();
            }
          }
          this.mapServices.getbufferShowFiles(true);
          this.mapServices.isParcelLayer = true;
          this.mapServices.ParcelData = [];
          this.mapServices.ParcelData = this.mapServices.allBuffersFeatures;
          this.sideNavService.decideComponent(
            this.mapServices.selectedBufferData
          );
        }
      });
  }

  selectMeasure(e: any) {
    this.measureType = e.target.value;
    this.sideNavService.selectedSubMethod = this.measureType;
    this.selectedSubMethod = this.sideNavService.selectedSubMethod;
  }
  onChangeBufferValue(event: any) {
    this.bufferValue = event.target.value;
    this.sideNavService.bufferValue = this.bufferValue;
  }
  getRadius() {
    let radius;
    this.showBufferParcel = true;
    if (this.measureType == 'Meters') {
      this.mapServices.result.getSource().clear();
      radius = parseInt(this.bufferValue);
    } else if (this.measureType == 'Kilometers') {
      this.mapServices.result.getSource().clear();
      radius = parseInt(this.bufferValue) * 1000;
    } else if (this.measureType == 'Feet') {
      this.mapServices.result.getSource().clear();
      radius = parseInt(this.bufferValue) * 0.3048;
    } else if (this.measureType == 'Miles') {
      this.mapServices.result.getSource().clear();
      radius = parseInt(this.bufferValue) * 1609.34;
    }
    return radius;
  }
  removeBuffer() {
    const backSource = this.mapServices.result.getSource();
    const features = this.mapServices.listResult.getFeatures();
    features.forEach((feature: any) => {
      backSource.removeFeature(feature);
    });
  }

  submitBuffer() {
    this.radius = this.getRadius();
    this.eventName = 'AdvancedSelect:Buffer:Run';
    switch (this.selectlayer) {
      case 'allLayers':
        this.selectlayer = 'All_Layers';
        break;

      default:
        this.selectlayer;
        break;
    }
    this.advanceSelectJson = {
      advanced_select_layer: `${this.selectlayer}`,
      advanced_select_buffer_units: `${this.measureType}`,
      advanced_select_buffer_value: `${this.bufferValue}`,
    };
    this.advanceSelectJson = JSON.stringify(this.advanceSelectJson);
    this.activityLoging();
    const format = new GeoJSON();
    const parser = new jsts.io.OL3Parser();
    parser.inject(
      Point,
      LineString,
      LinearRing,
      Polygon,
      MultiPoint,
      MultiLineString,
      MultiPolygon
    );
    const wkt = new WKT();
    this.innerData = [];
    this.unionResult = [];
    this.notUnioned = [];
    this.buffers = [];
    this.insideBuffers = [];
    this.finalFeature = '';
    this.mapServices.extentData = '';
    if (this.mapServices.selectedParcels.length > 1) {
      this.getBufferedFeatures();
      //Basic Buffer
      console.log(this.insideBuffers)
      this.union = this.parseBuffer(this.buffers);
      this.unionResult.push(this.union);
      while (this.notUnioned.length != 0) {
        const buffWkt = [];
        for (let i = 0; i < this.notUnioned.length; i++) {
          if (this.notUnioned[i].getCoordinates().length === 1) {
            const multi = new Polygon([this.notUnioned[i].getCoordinates()]);
            buffWkt.push(wkt.writeGeometry(multi));
          } else {
            const multi = new MultiPolygon([this.notUnioned[i].getCoordinates()]);
            buffWkt.push(wkt.writeGeometry(multi));
          }

        }
        this.union = this.parseBuffer(buffWkt);
        this.unionResult.push(this.union);
      }
      // Refine the buffer
      if (this.unionResult.length > 1) {
        // check intersection
        this.updateUnionIntersection(this.unionResult);
      }
      this.unionCount = this.unionResult.length;
      for (let i = 0; i < this.unionResult.length; i++) {
        const buffer = parser.write(this.unionResult[i]);
        this.selectedBuffers.push(buffer);
        this.drawBuffer(buffer);
      }

      for (let j = 0; j < this.insideBuffers.length; j++) {
        this.drawInsideBuffers(this.insideBuffers[j]);
      }
      this.mapServices.hideRunButton = false;
    } else {
      for (let i = 0; i < this.mapServices.selectedParcels.length; i++) {
        const feature = this.mapServices.selectedParcels[i];
        feature.getGeometry().transform('EPSG:3857', 'EPSG:4326');
        const data = format.writeFeature(feature);
        this.buffered = buffer(JSON.parse(data), this.radius / 1000, {
          units: 'kilometers',
        });
        const bufferedMercator = toMercator(this.buffered);
        this.bufferArea = format.readFeature(bufferedMercator);
        const testData = this.bufferArea.getGeometry();
        const polystyle = new Style({
          fill: new Fill({
            color: 'rgba(0, 255, 204, 0.3)',
          }),
          stroke: new Stroke({
            color: '#00FFCB',
            width: 3,
          }),
          zIndex: -1,
        });
        const mercatorFeature = toMercator(JSON.parse(data));
        const origionalFeature = format.readFeature(mercatorFeature);
        const bufferInner: any = origionalFeature.getGeometry();
        origionalFeature.setStyle(polystyle);
        this.mapServices.setAdvanceBuffer = true;
        this.bufferArea.set('buffer', 'Buffer');
        origionalFeature.set('buffer', 'Buffer');
        this.bufferArea.setStyle(
          new Style({
            stroke: new Stroke({
              color: '#00FFCB',
              width: 3,
            }),
            zIndex: -1,
          })
        );
        this.mapServices.listResult.addFeatures([
          this.bufferArea,
          origionalFeature,
        ]);
        const wkt = new WKT();
        this.pointGeometry = '';
        this.polygonGeometry = '';
        this.polygonGeometry = wkt.writeGeometry(testData);
        this.mapServices.polygonGeometry = wkt.writeGeometry(testData);
        this.mapServices.bufferPolygonGeometry.push(wkt.writeGeometry(testData))
        this.mapServices.innerBuffer.push(wkt.writeGeometry(bufferInner));
        // this.getAdvanceSelect();
        this.getCoordinatesData()
        this.mapServices.hideRunButton = false;
      }
    }
  }

  getBufferedFeatures() {
    // var geom, strGeom, input, buffer,inside_buff,
    this.radius = this.getRadius();
    const format = new GeoJSON();
    const wkt = new WKT();
    const reader = new jsts.io.WKTReader();
    const parser = new jsts.io.OL3Parser();
    parser.inject(
      Point,
      LineString,
      LinearRing,
      Polygon,
      MultiPoint,
      MultiLineString,
      MultiPolygon
    );
    for (let i = 0; i < this.mapServices.selectedParcels.length; i++) {
      const feature = this.mapServices.selectedParcels[i];
      const strGeom = wkt.writeFeature(feature);
      const input = reader.read(strGeom.toString());
      feature.getGeometry().transform('EPSG:3857', 'EPSG:4326');
      const geomGeojson = format.writeFeature(feature);
      this.buffered = buffer(JSON.parse(geomGeojson), this.radius / 1000, {
        units: 'kilometers',
      });
      const bufferedMercator = toMercator(this.buffered);
      const buffered = format.readFeature(bufferedMercator);
      const geombuff = buffered.getGeometry();
      const buffWkt = wkt.writeGeometry(geombuff);
      if (feature.getGeometry().getCoordinates().length === 1) {
          this.multiBuffered = buffWkt

        } else {
        const multi = new MultiPolygon([buffered.getGeometry().getCoordinates()]);
        const buffWkt = wkt.writeGeometry(multi);
      }

      this.buffers.push(buffWkt);
      const insideBuff = input.buffer(0);
      this.insideBuffers[i] = parser.write(insideBuff);
    }
  }
  parseBuffer(buffers: any) {
    // empty notUnionedde
    this.notUnioned = [];
    const parser = new jsts.io.OL3Parser();
    parser.inject(
      Point,
      LineString,
      LinearRing,
      Polygon,
      MultiPoint,
      MultiLineString,
      MultiPolygon
    );
    buffers.forEach((feature: any, index: number) => {
      if (index == 0) {
        const reader = new jsts.io.WKTReader();
        this.unionfound = reader.read(feature.toString());
      } else {
        const reader = new jsts.io.WKTReader();
        this.nextGeom = reader.read(feature.toString());
        this.intersection = this.unionfound.intersection(this.nextGeom);
        if (this.intersection && this.intersection.getArea() > 0) {
          this.unionfound = this.unionfound.union(this.nextGeom);
        } else {
          this.notUnioned.push(parser.write(this.nextGeom));
        }
      }
    });

    return this.unionfound;
  }

  updateUnionIntersection(buffers: any) {
    // Reset Union Intersection
    for (let i = 0; i < buffers.length; i++) {
      for (let j = 0; j < buffers.length; j++) {
        if (i != j) {
          this.currentGeom = buffers[i];
          this.nextGeom = buffers[j];
          this.intersection = this.currentGeom
            .intersection(this.nextGeom)
            .getArea();
          if (this.intersection > 0) {
            this.union = this.currentGeom.union(this.nextGeom);
            this.unionResult[i] = this.union;
            // Remove duplicate buffer
            if (j > -1) {
              this.unionResult.splice(j, 1);
            }
          }
        }
      }
    }
    return this.intersection;
  }
  drawBuffer(geom: any) {
    this.pointGeometry = '';
    // this.mapServices.polygonGeometry = '';
    const wkt = new WKT();
    this.mapServices.setAdvanceBuffer = true;
    // create an OL geometry object
    const geometry = geom.getCoordinates().length === 1 ? new Polygon(geom.getCoordinates()) : new MultiPolygon(geom.getCoordinates());

    if (geom.getCoordinates().length === 1) {
      this.feature = new Feature({
        geometry: new Polygon(geom.getCoordinates()),
        name: 'My Polygon2',
      });
      const multi = new Polygon([geom.getCoordinates()]);
      const buffWkt = wkt.writeGeometry(multi);
      this.polygonGeometry = buffWkt;
      this.mapServices.bufferPolygonGeometry.push(buffWkt)
    } else {
      const multi = new MultiPolygon([geom.getCoordinates()]);
      this.feature = new Feature({
        geometry: multi,
        name: 'My Polygon2',
      });
      const buffWkt = wkt.writeGeometry(multi);
      this.polygonGeometry = buffWkt;
      this.mapServices.bufferPolygonGeometry.push(buffWkt)
    }
    this.mapServices.setAdvanceBuffer = true;
    this.feature.set('buffer', 'Buffer');
    this.feature.setStyle(
      new Style({
        stroke: new Stroke({
          color: '#00FFCB',
          width: 3,
        }),
        zIndex: -1,
      })
    );

    this.mapServices.listResult.addFeatures([this.feature]);


    // this.getAdvanceSelect();
    this.getCoordinatesData()
  }
  drawInsideBuffers(insideGeom: any) {
    console.log('asd', this.mapServices.ParcelData )
    this.mapServices.setAdvanceBuffer = true;
    const wkt = new WKT();
    if (insideGeom.getCoordinates().length === 1) {
      this.insideFeature = new Feature({
        geometry: new Polygon(insideGeom.getCoordinates()),
        name: 'My Polygon2',
      });
      const multi = new Polygon([insideGeom.getCoordinates()]);
      const buffWkt = wkt.writeGeometry(multi);
      // this.mapServices.innerBuffer.push(buffWkt)
    } else {
      this.insideFeature = new Feature({
        geometry: new MultiPolygon(insideGeom.getCoordinates()),
        name: 'My Polygon2',
      });

      // create a multipolygon geometry from the polygon geometry
      // this.mapServices.innerBuffer.push(this.multiBuffered)
    }
    console.log('apna' ,this.insideFeature)
    this.mapServices.setAdvanceBuffer = true;
    this.insideFeature.set('buffer', 'Buffer');
    this.insideFeature.setStyle(
      new Style({
        fill: new Fill({
          color: 'rgba(0, 255, 204, 0.3)',
        }),
        stroke: new Stroke({
          color: '#00FFCB',
          width: 3,
        }),
        zIndex: -1,
      })
    );
    this.mapServices.listResult.addFeatures([this.insideFeature]);

    // this.mapServices.setAdvanceBuffer = true;
    // insideGeom.set('buffer', 'Buffer');
    // insideGeom.setStyle(new Style({
    //   fill: new Fill({
    //     color: 'rgba(0, 255, 204, 0.3)',
    //   }),
    //   stroke: new Stroke({
    //     color: '#00FFCB',
    //     width: 3,
    //   }),
    //   zIndex: -1,
    // }))
    // this.mapServices.listResult.addFeatures([insideGeom]);
  }
  closeLeftPanel() {
    // this.mapServices.stopHover = true;
    this.sideNavService.isLoadedFeature('false');
    this.advanceLayer && this.advanceLayer.getSource().clear();
    this.mapServices.mapLayer.removeInteraction(this.draw);
    this.mapServices.getdrawEnable(false);
    this.mapServices.setClosePanel(true);
    this.mapServices.closePanel = true;
  }
  clearSelection(event: any) {
    event.stopPropagation();
    event.preventDefault();
    this.mapServices.ParcelData = [];
    this.mapServices.innerBuffer = []
    this.mapServices.bufferPolygonGeometry = []
    this.mapServices.hideRunButton = true;
    this.mapServices.getbufferShowFiles(false);
    this.mapServices.isParcelLayer = false;
    this.mapServices.selectedParcels = [];
    this.mapServices.allBuffersFeatures = [];
    this.mapServices.selectedBufferData = [];
    this.sideNavService.isLoadedFeature('false');
    this.sideNavService.closeRightSideNav();
    this.sideNavService.sideNavState('close');
    this.sideNavService.infoSideNav('closed');
    const backSource = this.mapServices.result.getSource();
    const features = this.mapServices.listResult.getFeatures();
    features.forEach((feature: any) => {
      backSource.removeFeature(feature);
    });
  }
  activityLoging() {
    if (!this.pointGeometry) {
      this.pointGeometry = '';
    }
    if (!this.polygonGeometry) {
      this.polygonGeometry = '';
    }
    this.http
      .get('https://api.ipify.org/?format=json')
      .subscribe((res: any) => {
        this.mapServices.ipAddress = res.ip;
        const body = {
          map_id: this.mapId.toString(),
          event: 'Click',
          page: this.mapServices.pageUrl,
          basemap: this.mapServices.shareCurrentMap,
          event_name: this.eventName,
          ip: this.mapServices.ipAddress,
          time: this.mapServices.getTimeOnPage().toString(),
          point: this.pointGeometry,
          wkt: this.polygonGeometry,
          layer_ids: this.layersId,
          event_information: this.advanceSelectJson,
        };
        this.mapServices.activityLogs(body).subscribe(
          () => {
            // console.log('a');
          },
          (error: any) => {
            if (error.status == 403) {
              location.reload();
            }
          }
        );
      });
  }

  @HostListener('unloaded')
  ngOnDestroy() {
    this.advanceLayer && this.advanceLayer.getSource().clear();
    this.mapServices.mapLayer.removeInteraction(this.draw);
    this.mapServices.getdrawEnable(false)
  }
}
